import { Button, Flex, Input, Label, Table, useDebounce } from '@fareye/ui'
import { dMmm, FaDownload, isEmpty, FaSearch } from '@fareye/utils'
import React from 'react'
import { getTableColumns } from '../../MultiModelHistory/component/Column'
import { useTranslation, downloadToCSV } from '@fareye/common'
import { formatItemLabelForCSV } from '../../../utility/function'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: '#FFFFFF',
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: '#DADADA',
    width: 'fit-content',
    marginBottom: '8px'
  },
  searchInput: {
    margin: '15px 0px 4px',
    boxSizing: 'border-box',
    width: '100%',
    fontSize: 12,
    lineHeight: 1,
    background: '#fff',
    borderColor: 'hsl(0,0%,80%)',
    color: 'rgba(151,151,151,1)'
  },
  searchIcon: { position: 'absolute', right: 10, top: 24, color: '#727272' },
  noData: {
    width: '100%',
    paddingTop: '10vmax',
    textAlign: 'center',
    display: 'block'
  }
}
const ParcelItemDetails = ({ data, config }: any) => {
  const { columns } = config
  const tableData = data.itemsDetail
  const [searchInput, setSearchInput] = React.useState('')
  const debouncedSearchTerm = useDebounce(searchInput, 400)
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const [filteredData, setFilteredData] = React.useState([])

  const displayDataFlag = !isEmpty(tableData)
  const { t } = useTranslation()
  React.useEffect(() => {
    setFilteredData(
      isEmpty(searchInput)
        ? tableData
        : tableData.filter((item: any) =>
            Object.values(item).includes(searchInput)
          )
    )
  }, [debouncedSearchTerm])
  let translatedTableData = tableData
  translatedTableData = translatedTableData.map((item: any) => {
    return {
      ...item,
      itemName: t(item.itemName),
      itemStatus: t(item.itemStatus)
    }
  })
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Label style={{ fontSize: '16px', fontWeight: 600 }}>
          {t('Item Details')}
        </Label>
        {displayDataFlag && (
          <Flex justifyContentSpaceBetween>
            <div style={{ position: 'relative', width: 200 }}>
              <Input
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSearchInput(e.target.value)
                }
                placeholder={t('Search Items')}
                style={style.searchInput}
              />
              <FaSearch style={style.searchIcon} />
            </div>
            <Button
              disabled={false}
              isLoading={false}
              variant="s primary"
              style={{ height: '30px', margin: '15px 0px 4px' }}
              onClick={() => {
                setDownloadLoading(true)
                downloadToCSV({
                  data: formatItemLabelForCSV(translatedTableData, columns),
                  fileName: `itemDetail_${dMmm()}`
                })
                setDownloadLoading(false)
              }}
            >
              {t('Download CSV')}
              <FaDownload style={style.downloadIcon} />
            </Button>
          </Flex>
        )}
      </Flex>
      {!isEmpty(filteredData) ? (
        <Table
          className="striped responsive"
          sortable={false}
          showTotalCount={false}
          totalElements={100}
          data={filteredData}
          showPagination={false}
          columns={getTableColumns(columns, { t })}
        />
      ) : (
        <Label style={style.noData}>{t('No Data')}</Label>
      )}
    </Flex>
  )
}
export default ParcelItemDetails
